import { render, staticRenderFns } from "./AMHatsuBattleship.vue?vue&type=template&id=769f8ce4&scoped=true"
import script from "./AMHatsuBattleship.vue?vue&type=script&lang=ts"
export * from "./AMHatsuBattleship.vue?vue&type=script&lang=ts"
import style0 from "./AMHatsuBattleship.vue?vue&type=style&index=0&id=769f8ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769f8ce4",
  null
  
)

export default component.exports